import styled from 'styled-components';

import Buttons from '@klv/molecules/buttons';
import Icon from '@klv/atoms/icon';
import Typography from '@klv/atoms/typography';
import Grid from '@klv/utils/grid';

import { clampSize } from '@klv/shared/utils/functions';
import type { DesignSystemColorTypes } from '@klv/shared/styles/colors';

export const StyledTextTagline = styled.div`
  ${({ theme }) => `
    ${theme.globalPadding}
  `}
`;

export const StyledGrid = styled(Grid)`
  justify-items: center;
`;

export const Flag = styled(Icon)`
  color: ${({ theme }) => theme.colors.charcoal};
  grid-column: 1 / -1;
`;

export const Headline = styled.h1<{ $color: DesignSystemColorTypes; }>`
  font-size: ${clampSize(4.575, 10.8)};
  grid-column: 1 / -1;
  letter-spacing: 0.05em;
  line-height: 91%;
  margin-top: 2.8rem;
  text-align: center;
  text-transform: uppercase;

  ${({ $color, theme }) => `
    ${theme.fonts.sohneSchmal.bold}
    color: ${theme.colors[$color]};
  `}
`;

export const Subhead = styled(Typography)`
  grid-column: 1 / -1;
  margin-top: 4rem;
  text-align: center;

  ${({ theme }) => `
    color: ${theme.colors.gray90};
  `}
`;

export const StyledButtons = styled(Buttons)`
  grid-column: 1 / -1;
  margin-top: 4rem;
`;
